module.exports = __webpack_public_path__ + "static/img/GO_Banner.201636b.jpg";